/* eslint-disable */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import moment from 'moment';
import UpdateModal from '../components/UpdateModal';
import * as actions from '../action';
import * as c from '../constant';

import FeesTaggingContainer from './FeesTaggingContainer';

function DiscountPenaltyContainer({
  getPenaltyComputationList,
  getDiscountPenaltyList,
  discountPenaltyList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getDiscountPenaltyList();
    getPenaltyComputationList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const handleEdit = (data) => (e) => {
    e.preventDefault();

    const args = {
      ...data.attributes,
      date_before_penalty_start: moment(
        _.get(data, 'attributes.date_before_penalty_start')
      ).format('MM/DD/YYYY'),
      last_date_with_discount: moment(
        _.get(data, 'attributes.last_date_with_discount')
      ).format('MM/DD/YYYY'),
    };

    setModal({
      isOpen: true,
      content: <UpdateModal updateList={args} />,
      title: 'Update Discount and Penalty',
      modalSize: 'modal-lg',
    });
  };

  const interestComputation = (data) => {
    if (data === 'F') {
      return 'Fees Only';
    }
    if (data === 'SF') {
      return 'Surcharge + Fees';
    }
    return '';
  };

  const formatDate = (value) =>
    value ? moment(value).format('MMMM DD, YYYY') : 'N/A';

  const getDisplayValue = (value) =>
    _.isNil(value) || value === '' ? 'N/A' : value;

  const attributes = _.get(discountPenaltyList, 'attributes', {});

  const discountPenalty = [
    { label: 'Year', value: _.get(attributes, 'year') },
    {
      label: 'Monthly Interest Rate',
      value: _.get(attributes, 'additional_monthly_penalty_percentage'),
    },
    { label: 'Discount Rate', value: _.get(attributes, 'discount_percentage') },
    {
      label: 'Maximum Monthly Interest Rate',
      value: _.get(attributes, 'maximum_penalty_percentage'),
    },
    {
      label: 'First Month Day of Penalty',
      value: _.get(attributes, 'month_day_before_penalty_update'),
    },
    { label: 'Surcharge Rate', value: _.get(attributes, 'initial_penalty_percentage') },
    {
      label: 'Last Day of Renewal Period',
      value: formatDate(_.get(attributes, 'date_before_penalty_start')),
    },
    {
      label: 'Last Date with Discount',
      value: formatDate(_.get(attributes, 'last_date_with_discount')),
    },
    {
      label: 'Gross Additional Rate',
      value: _.get(attributes, 'gross_additional_percentage'),
    },
    { label: 'Essential Rate', value: _.get(attributes, 'essential_rate') },
    {
      label: 'Change Request Processing Fee',
      value: _.get(attributes, 'change_request_processing_fee'),
    },
    {
      label: 'Retirement Processing Fee',
      value: _.get(attributes, 'retirement_processing_fee'),
    },
    { label: 'Basis of Penalty', value: _.get(attributes, 'basis_of_penalty') },
    {
      label: 'Interest Computation',
      value: interestComputation(_.get(attributes, 'penalty_computation')),
    },
    {
      label: 'Revoke Permit',
      value: _.get(attributes, 'revoked_permit_reapplication_description'),
    },
    {
      label: 'Retire Delinquent Business',
      value: _.get(attributes, 'retire_delinquent_business_description'),
    },
    {
      label: 'Penalty Display in View OR',
      value: _.get(attributes, 'penalty_display_in_or_description'),
    },
    {
      label: 'Start of Interest',
      value: _.get(attributes, 'start_of_interest_description'),
    },
    { label: 'Retention Rate', value: _.get(attributes, 'retention_rate') },
    {
      label: 'Minimum Payable Amount',
      value: _.get(attributes, 'minimum_payable_amount'),
    },
  ];

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6 p-3">
              <h3>Discount and Penalty</h3>
            </div>
            <div className="col-6 d-flex">
              <button
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold ml-auto px-4 mr-1"
                onClick={handleEdit(discountPenaltyList)}
              >
                Update
              </button>
            </div>
            <div className="col-12">
              <div
                className="table-responsive"
                style={{
                  maxHeight: '62vh',
                  overflowY: 'auto',
                  overflowX: 'auto',
                  border: '1px solid #e9ecef',
                  borderRadius: '12px',
                  backgroundColor: '#fff',
                }}
              >
                <table className="table table-striped table-borderless mb-0">
                  <tbody>
                    {discountPenalty.map((item) => (
                      <tr key={item.label}>
                        <td className="text-dark px-3 py-3">{item.label}</td>
                        <td className="text-right px-3 py-3">
                          <b>{getDisplayValue(item.value)}</b>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FeesTaggingContainer ordinanceRevisionId={ordinanceRevisionId} />
    </div>
  );
}

DiscountPenaltyContainer.propTypes = {
  getDiscountPenaltyList: PropTypes.instanceOf(Function).isRequired,
  discountPenaltyList: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  discountPenaltyList: _.get(api, `${c.GET_DISCOUNT_PENALTY_LIST}.item`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DiscountPenaltyContainer);
